import axios from "axios";
import {Message} from 'element-ui'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 15000
});

// response 拦截器
service.interceptors.response.use(
  response => {
    const result = response.data;
    /**
     * 非200即抛错
     */
    if (result.code !== 200) {
      Message({
        message: result.message,
        type: 'error',
      })
      return Promise.reject('error');
    } else {
      return response.data;
    }
  },

  error => {
    if (!(error.message.indexOf('timeout') > -1 && error.config.url.indexOf('mail') > -1)) {
      Message({
        message: error.message,
        type: 'error'
      })
    }
    return Promise.reject(error);
  }
);

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js